var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiningTable = function SvgDiningTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dining-table_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6 4.5h8A1.5 1.5 0 0 1 15.5 6v1.5h-11V6A1.5 1.5 0 0 1 6 4.5Z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "dining-table_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9h4a2 2 0 0 1 2 2v5H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-1 8h5a3 3 0 0 1 3 3H5a1 1 0 0 0-1-1H1zm7 8H0zm-7 0V8l2 2v6zm5-8a3 3 0 0 1 3 3v5H5v-5a1 1 0 0 0-1-1z",
    mask: "url(#dining-table_svg__b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "dining-table_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 9h-4a2 2 0 0 0-2 2v5h6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 8h-5a3 3 0 0 0-3 3h2a1 1 0 0 1 1-1h3zm-7 8h6zm7 0V8l-2 2v6zm-5-8a3 3 0 0 0-3 3v5h2v-5a1 1 0 0 1 1-1z",
    mask: "url(#dining-table_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 7a.5.5 0 0 1 .5.5V15h-1V7.5A.5.5 0 0 1 10 7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 1,
    x: 1,
    y: 4,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(90 1 4)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 1,
    x: 20,
    y: 4,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(90 20 4)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    x: 13,
    y: 16,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-180 13 16)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    x: 6,
    y: 13,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-180 6 13)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    x: 20,
    y: 13,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-180 20 13)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dining-table_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgDiningTable;